<template>
	<select :value="value" @input="updateValue" :disabled="!!(formMode == 'edit' && uneditable == true)">
		<option
			:key="`select-option-${i}`"
			:value="optionValue(option)"
			:selected="option === value"
			v-for="(option, i) in options"
		>{{ displayName(option) }}</option>
	</select>
</template>
<script>
/** @format */

export default {
	name: 'BaseSelect',
	props: {
		label: {
			type: String
		},
		trackBy: {
			type: String
		},
		formMode: {
			type: String,
			required: true
		},
		uneditable: {
			type: Boolean,
			default: false,
		},
		options: {
			type: Array
		},
		onChange: {
			type: Function
		},
		value: [String, Number]
	},
	methods: {
		displayName(o) {
			if (typeof o == 'object') {
				if (o[this.label]) return o[this.label];
			}
			return o;
		},
		optionValue(o) {
			if (typeof o == 'object') {
				if (o[this.trackBy]) return o[this.trackBy];
			}
			return o;
		},
		updateValue(e) {
			this.$emit('input', e.target.value);
			if (this.onChange) {
				this.onChange(e.target.value);
			}
		}
	}
};
</script>
